import { render, staticRenderFns } from "./u-pagination-text-tile.vue?vue&type=template&id=dd97fc6a&scoped=true"
import script from "./u-pagination-text-tile.vue?vue&type=script&lang=js"
export * from "./u-pagination-text-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd97fc6a",
  null
  
)

export default component.exports